import { CheckMarkIcon } from "@/app/icons/check-mark"
import { PlusIcon } from "@/app/icons/plus"
import { WalletConnectMoleculeReatom } from "@/app/wallet-connect/store.reatom"
import type { NftMiniature } from "@anaconda/core/nft/types"
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  cn,
} from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { NftsToBuyMoleculeReatom } from "../buy/nfts-to-buy/molecule.reatom"
import { useCartPaymentSupport } from "../buy/nfts-to-buy/use-cart-payment-support"

interface Props {
  nft: NftMiniature
  className?: string
}

export const NftSelectionToggle = reatomComponent<Props>(
  ({ nft, className }: Props) => {
    const { selectedNftsToBuy, toggleNftSelection, isNftSelectable } =
      useMolecule(NftsToBuyMoleculeReatom)
    const { unionAddress } = useMolecule(WalletConnectMoleculeReatom)

    const selectedNfts = selectedNftsToBuy()
    const userWallet = unionAddress()
    const paymentSupport = useCartPaymentSupport(nft.collection.blockchain)
    const selectableState = isNftSelectable(nft, userWallet, paymentSupport)
    const selected = selectedNfts.some(({ id }) => id === nft.id)
    const selectionAvailable = true // Always available in buy context

    if (!selectionAvailable) return null

    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            size="icon"
            disabled={!selectableState.selectable}
            className={cn(
              "h-6 w-6 rounded-full border hover:scale-105",
              // pointer-events-auto is needed to prevent click on link under the button
              "disabled:pointer-events-auto disabled:cursor-not-allowed disabled:opacity-60",
              selected
                ? "border-transparent bg-brand text-muted"
                : "border-white/20 bg-black/40 text-white backdrop-blur-[10px]",
              className,
            )}
            onClick={() => {
              console.log("[NftSelectionToggle] Toggling NFT:", nft.id)
              toggleNftSelection(nft)
            }}
          >
            {selected ? <CheckMarkIcon /> : <PlusIcon />}
          </Button>
        </TooltipTrigger>
        {"reason" in selectableState ? (
          <TooltipContent>{selectableState.reason}</TooltipContent>
        ) : null}
      </Tooltip>
    )
  },
  "NftSelectionToggle",
)
